import React from "react";
import "./index.scss";

type Props = {
  name: string;
  value?: string | number;
  percent?: number;
  data?: number[];
};

function KpiCard({
  name,
  value = "0",
  percent = 0,
  data = [10, 20, 15, 30, 25, 40, 35],
}: Props) {
  const isPositive = percent >= 0;

  const width = 220;
  const height = 60;

  const max = Math.max(...data);
  const min = Math.min(...data);

  // ✅ transform points
  const points = data.map((d, i) => {
    const x = (i / (data.length - 1)) * width;
    const y = height - ((d - min) / (max - min || 1)) * height;
    return { x, y };
  });

  // ✅ smooth line
  const linePath = points
    .map((p, i) => (i === 0 ? `M ${p.x},${p.y}` : `L ${p.x},${p.y}`))
    .join(" ");

  // ✅ fill area under curve
  const areaPath =
    linePath +
    ` L ${width},${height} L 0,${height} Z`;

  // ✅ detect variant from KPI name
  const getVariant = () => {
    const key = name.toLowerCase();
    if (key.includes("order")) return "orders";
    if (key.includes("revenue") || key.includes("sales")) return "revenue";
    if (key.includes("user") || key.includes("client")) return "users";
    if (key.includes("product")) return "products";
    return "default";
  };

  const variant = getVariant();

  return (
    <div className={`kpi-card variant-${variant}`}>
      <div className="kpi-top">
        <p className="kpi-title">{name}</p>

        <span className={`kpi-badge ${isPositive ? "up" : "down"}`}>
          {isPositive ? "+" : ""}
          {percent}%
        </span>
      </div>

      <div className="kpi-middle">
        <h2 className="kpi-value">{value}</h2>
      </div>

      <div className="kpi-chart">
        <svg width="100%" height="70" viewBox={`0 0 ${width} ${height}`}>
          {/* ✅ some variants will have filled curve */}
          {(variant === "revenue" || variant === "users") && (
            <path className="chart-area" d={areaPath} />
          )}

          {/* ✅ all variants have line */}
          <path className="chart-line" d={linePath} fill="none" />
        </svg>
      </div>
    </div>
  );
}

export default KpiCard;
